import axios from 'axios';

// Determine base URL from environment or fallback
const baseURL =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:5000/api'
    : 'https://dibyanjaya-portfolio-backend.onrender.com/api');

// Create Axios instance
const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach Bearer token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log(`[Axios] Request to ${config.url}`, config);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle global errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      console.warn('Unauthorized access. Redirecting to login...');
      // Optionally redirect to login page
      // window.location.href = '/login';
    }

    if (status >= 500) {
      console.error('Server error:', error?.response?.data || error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
